// MY CHRISTMAS — i18n for the personalization evolution (Meu Natal, wizard, world, moment).
export const extra7 = {
  pt: {
    "nav.world": "Natal pelo Mundo", "nav.create": "Criar Meu Natal",
    "create.cta_title": "Criar Meu Natal",
    "create.cta_sub": "Responda algumas perguntas e deixe o MY CHRISTMAS ajudar a organizar cada detalhe.",
    "create.start": "Começar",
    "create.quick_title": "Preciso organizar meu Natal rápido",
    "create.quick_sub": "Responda algumas perguntas e receba um plano simplificado.",
    "create.quick_go": "Modo rápido",
    "dash.welcome_new": "Bem-vindo ao MY CHRISTMAS",
    "dash.welcome_new_sub": "Vamos preparar o seu Natal?",
    "dash.welcome_back": "Bem-vindo de volta",
    "dash.continue": "Criar meu Planejamento",
    "dash.now_title": "O que fazer agora",
    "dash.tasks_title": "Próximas tarefas",
    "dash.tools": "Ferramentas",
    "dash.discover": "Descobrir",
    "dash.days_left": "Faltam {n} dias para o Natal 🎄",
    "dash.days_today": "É hoje! Feliz Natal 🎄",
    "dash.taking_shape": "Seu Natal está tomando forma.",
    "dash.your_plan": "Seu plano automático", "dash.block_done": "Etapa concluída", "dash.block_over": "Salvamento {v} acima do orçamento",
    "dash.reserved": "Orçamento reservado",
    "dash.edit_plan": "Editar meu Natal",
    "wiz.title": "Vamos preparar o seu Natal? 🎄",
    "wiz.step": "Etapa {n} de {total}",
    "wiz.q_country": "Onde será o seu Natal?",
    "wiz.q_country_sub": "Isso define moeda, produtos e referências do seu mercado.",
    "wiz.q_language": "Em qual idioma você prefere navegar?",
    "wiz.q_guests": "Quantas pessoas vão celebrar com você?",
    "wiz.q_audience": "Quem estará com você?",
    "wiz.q_audience_sub": "Opcional — nos ajuda a planejar melhor.",
    "wiz.q_budget": "Quanto você pretende investir no seu Natal?",
    "wiz.budget_custom": "Ou digite o valor que você vai usar",
    "wiz.budget_over": "O valor está acima do orçado",
    "wiz.q_split": "Quer dividir seu orçamento?",
    "wiz.split_auto": "Deixe o MY CHRISTMAS sugerir a divisão",
    "wiz.split_manual": "Quero dividir manualmente",
    "wiz.q_style": "Qual Natal combina mais com você?",
    "wiz.q_haves": "O que você já tem em casa?",
    "wiz.q_haves_sub": "Assim não sugerimos comprar o que você já possui.",
    "wiz.q_ceia": "Você pretende preparar a ceia?",
    "wiz.q_ceia_level": "Que tipo de ceia?",
    "wiz.q_dietary": "Precisamos considerar alguma preferência alimentar?",
    "wiz.q_secretsanta": "Vai ter Amigo Oculto? 🎁",
    "wiz.q_name": "Dê um nome ao seu Natal",
    "wiz.q_name_sub": "Ele vai aparecer no seu painel.",
    "wiz.q_cover": "Escolha uma capa",
    "wiz.name_ph": "Ex.: Natal Feliz",
    "wiz.processing": "Estamos preparando o seu Natal...",
    "wiz.p1": "Organizando seu orçamento...",
    "wiz.p2": "Selecionando inspirações...",
    "wiz.p3": "Pensando na sua ceia...",
    "wiz.p4": "Preparando seu planejamento...",
    "wiz.p5": "Organizando sua lista...",
    "wiz.ready": "Seu Natal está pronto para começar",
    "wiz.summary": "Resumo do seu Natal",
    "wiz.finish": "Ver meu Natal",
    "wiz.next": "Continuar", "wiz.back": "Voltar", "wiz.skip": "Pular",
    "wiz.guests_other": "Outra quantidade:", "wiz.guests_ph": "ex.: 12", "wiz.people": "pessoas", "wiz.yes": "Sim", "wiz.no": "Não",
    "wiz.quick_badge": "Modo rápido",
    "wiz.q_quick_needs": "O que você precisa organizar?",
    "split.decoration": "Decoração", "split.ceia": "Ceia", "split.gifts": "Presentes",
    "split.table": "Mesa", "split.others": "Outros", "split.total": "Total",
    "world.title": "Natal pelo Mundo",
    "world.sub": "Descubra como diferentes lugares celebram uma das épocas mais especiais do ano.",
    "world.explore": "Explorar", "world.back": "Voltar ao mundo",
    "world.decoration": "Decoração", "world.food": "Comidas", "world.dessert": "Sobremesas",
    "world.tradition": "Tradições", "world.table": "Mesa", "world.curiosity": "Curiosidades",
    "world.note": "Conteúdo cultural em revisão — apresentado com respeito às muitas formas de celebrar.",
    "surprise.btn": "Surpreenda-me",
    "surprise.title": "Uma sugestão para você",
    "surprise.again": "Ver outra",
    "surprise.see": "Ver",
    "moment.choose": "Escolha uma experiência para viver antes da ceia.",
    "moment.prayer_card": "Oração de Natal",
    "moment.prayer_desc": "Uma oração cristã para ser lida em família.",
    "moment.gratitude_card": "Mensagem de Gratidão em Família",
    "moment.gratitude_desc": "Uma mensagem calorosa, para qualquer família.",
    "moment.open": "Abrir",
    "moment.reading_mode": "Modo Leitura",
    "moment.exit_reading": "Sair do modo leitura",
    "moment.back_choose": "Escolher outra experiência",
  },
  en: {
    "nav.world": "Christmas Around the World", "nav.create": "Create My Christmas",
    "create.cta_title": "Create My Christmas",
    "create.cta_sub": "Answer a few questions and let MY CHRISTMAS help organize every detail.",
    "create.start": "Start",
    "create.quick_title": "I need to organize my Christmas fast",
    "create.quick_sub": "Answer a few questions and get a simplified plan.",
    "create.quick_go": "Quick mode",
    "dash.welcome_new": "Welcome to MY CHRISTMAS",
    "dash.welcome_new_sub": "Shall we prepare your Christmas?",
    "dash.welcome_back": "Welcome back",
    "dash.continue": "Create my Planning",
    "dash.now_title": "What to do now",
    "dash.tasks_title": "Next tasks",
    "dash.tools": "Tools",
    "dash.discover": "Discover",
    "dash.days_left": "{n} days until Christmas 🎄",
    "dash.days_today": "It's today! Merry Christmas 🎄",
    "dash.taking_shape": "Your Christmas is taking shape.",
    "dash.your_plan": "Your automatic plan", "dash.block_done": "Step done", "dash.block_over": "A save is {v} over budget",
    "dash.reserved": "Budget reserved",
    "dash.edit_plan": "Edit my Christmas",
    "wiz.title": "Shall we prepare your Christmas? 🎄",
    "wiz.step": "Step {n} of {total}",
    "wiz.q_country": "Where will your Christmas be?",
    "wiz.q_country_sub": "This sets your market's currency, products and references.",
    "wiz.q_language": "Which language do you prefer?",
    "wiz.q_guests": "How many people will celebrate with you?",
    "wiz.q_audience": "Who will be with you?",
    "wiz.q_audience_sub": "Optional — it helps us plan better.",
    "wiz.q_budget": "How much do you plan to invest in your Christmas?",
    "wiz.budget_custom": "Or type the amount you'll use",
    "wiz.budget_over": "The amount is above your budget",
    "wiz.q_split": "Want to split your budget?",
    "wiz.split_auto": "Let MY CHRISTMAS suggest the split",
    "wiz.split_manual": "I'll split it manually",
    "wiz.q_style": "Which Christmas suits you best?",
    "wiz.q_haves": "What do you already have at home?",
    "wiz.q_haves_sub": "So we don't suggest buying what you already own.",
    "wiz.q_ceia": "Do you plan to prepare the dinner?",
    "wiz.q_ceia_level": "What kind of dinner?",
    "wiz.q_dietary": "Any dietary preference we should consider?",
    "wiz.q_secretsanta": "Will there be a Secret Santa? 🎁",
    "wiz.q_name": "Name your Christmas",
    "wiz.q_name_sub": "It will appear on your dashboard.",
    "wiz.q_cover": "Choose a cover",
    "wiz.name_ph": "e.g. Merry Christmas",
    "wiz.processing": "We're preparing your Christmas...",
    "wiz.p1": "Organizing your budget...",
    "wiz.p2": "Selecting inspirations...",
    "wiz.p3": "Thinking about your dinner...",
    "wiz.p4": "Preparing your planning...",
    "wiz.p5": "Organizing your list...",
    "wiz.ready": "Your Christmas is ready to begin",
    "wiz.summary": "Your Christmas summary",
    "wiz.finish": "See my Christmas",
    "wiz.next": "Continue", "wiz.back": "Back", "wiz.skip": "Skip",
    "wiz.guests_other": "Other number:", "wiz.guests_ph": "e.g. 12", "wiz.people": "people", "wiz.yes": "Yes", "wiz.no": "No",
    "wiz.quick_badge": "Quick mode",
    "wiz.q_quick_needs": "What do you need to organize?",
    "split.decoration": "Decoration", "split.ceia": "Dinner", "split.gifts": "Gifts",
    "split.table": "Table", "split.others": "Others", "split.total": "Total",
    "world.title": "Christmas Around the World",
    "world.sub": "Discover how different places celebrate one of the most special times of the year.",
    "world.explore": "Explore", "world.back": "Back to the world",
    "world.decoration": "Decoration", "world.food": "Food", "world.dessert": "Desserts",
    "world.tradition": "Traditions", "world.table": "Table", "world.curiosity": "Curiosities",
    "world.note": "Cultural content under review — presented with respect for the many ways to celebrate.",
    "surprise.btn": "Surprise me",
    "surprise.title": "A suggestion for you",
    "surprise.again": "See another",
    "surprise.see": "See",
    "moment.choose": "Choose an experience to live before dinner.",
    "moment.prayer_card": "Christmas Prayer",
    "moment.prayer_desc": "A Christian prayer to read as a family.",
    "moment.gratitude_card": "Family Gratitude Message",
    "moment.gratitude_desc": "A warm message, for any family.",
    "moment.open": "Open",
    "moment.reading_mode": "Reading Mode",
    "moment.exit_reading": "Exit reading mode",
    "moment.back_choose": "Choose another experience",
  },
  es: {
    "nav.world": "Navidad por el Mundo", "nav.create": "Crear Mi Navidad",
    "create.cta_title": "Crear Mi Navidad",
    "create.cta_sub": "Responde algunas preguntas y deja que MY CHRISTMAS ayude a organizar cada detalle.",
    "create.start": "Empezar",
    "create.quick_title": "Necesito organizar mi Navidad rápido",
    "create.quick_sub": "Responde algunas preguntas y recibe un plan simplificado.",
    "create.quick_go": "Modo rápido",
    "dash.welcome_new": "Bienvenido a MY CHRISTMAS",
    "dash.welcome_new_sub": "¿Preparamos tu Navidad?",
    "dash.welcome_back": "Bienvenido de nuevo",
    "dash.continue": "Crear mi Planificación",
    "dash.now_title": "Qué hacer ahora",
    "dash.tasks_title": "Próximas tareas",
    "dash.tools": "Herramientas",
    "dash.discover": "Descubrir",
    "dash.days_left": "Faltan {n} días para Navidad 🎄",
    "dash.days_today": "¡Es hoy! Feliz Navidad 🎄",
    "dash.taking_shape": "Tu Navidad va tomando forma.",
    "dash.your_plan": "Tu plan automático", "dash.block_done": "Etapa completada", "dash.block_over": "Guardado {v} por encima del presupuesto",
    "dash.reserved": "Presupuesto reservado",
    "dash.edit_plan": "Editar mi Navidad",
    "wiz.title": "¿Preparamos tu Navidad? 🎄",
    "wiz.step": "Paso {n} de {total}",
    "wiz.q_country": "¿Dónde será tu Navidad?",
    "wiz.q_country_sub": "Define la moneda, los productos y las referencias de tu mercado.",
    "wiz.q_language": "¿En qué idioma prefieres navegar?",
    "wiz.q_guests": "¿Cuántas personas celebrarán contigo?",
    "wiz.q_audience": "¿Quién estará contigo?",
    "wiz.q_audience_sub": "Opcional — nos ayuda a planear mejor.",
    "wiz.q_budget": "¿Cuánto piensas invertir en tu Navidad?",
    "wiz.budget_custom": "O escribe el importe que vas a usar",
    "wiz.budget_over": "El importe supera tu presupuesto",
    "wiz.q_split": "¿Quieres dividir tu presupuesto?",
    "wiz.split_auto": "Deja que MY CHRISTMAS sugiera la división",
    "wiz.split_manual": "Quiero dividirlo manualmente",
    "wiz.q_style": "¿Qué Navidad va más contigo?",
    "wiz.q_haves": "¿Qué tienes ya en casa?",
    "wiz.q_haves_sub": "Así no sugerimos comprar lo que ya tienes.",
    "wiz.q_ceia": "¿Piensas preparar la cena?",
    "wiz.q_ceia_level": "¿Qué tipo de cena?",
    "wiz.q_dietary": "¿Alguna preferencia alimentaria a considerar?",
    "wiz.q_secretsanta": "¿Habrá amigo invisible? 🎁",
    "wiz.q_name": "Dale un nombre a tu Navidad",
    "wiz.q_name_sub": "Aparecerá en tu panel.",
    "wiz.q_cover": "Elige una portada",
    "wiz.name_ph": "Ej.: Feliz Navidad",
    "wiz.processing": "Estamos preparando tu Navidad...",
    "wiz.p1": "Organizando tu presupuesto...",
    "wiz.p2": "Seleccionando inspiraciones...",
    "wiz.p3": "Pensando en tu cena...",
    "wiz.p4": "Preparando tu planificación...",
    "wiz.p5": "Organizando tu lista...",
    "wiz.ready": "Tu Navidad está lista para comenzar",
    "wiz.summary": "Resumen de tu Navidad",
    "wiz.finish": "Ver mi Navidad",
    "wiz.next": "Continuar", "wiz.back": "Volver", "wiz.skip": "Saltar",
    "wiz.guests_other": "Otra cantidad:", "wiz.guests_ph": "p. ej. 12", "wiz.people": "personas", "wiz.yes": "Sí", "wiz.no": "No",
    "wiz.quick_badge": "Modo rápido",
    "wiz.q_quick_needs": "¿Qué necesitas organizar?",
    "split.decoration": "Decoración", "split.ceia": "Cena", "split.gifts": "Regalos",
    "split.table": "Mesa", "split.others": "Otros", "split.total": "Total",
    "world.title": "Navidad por el Mundo",
    "world.sub": "Descubre cómo distintos lugares celebran una de las épocas más especiales del año.",
    "world.explore": "Explorar", "world.back": "Volver al mundo",
    "world.decoration": "Decoración", "world.food": "Comidas", "world.dessert": "Postres",
    "world.tradition": "Tradiciones", "world.table": "Mesa", "world.curiosity": "Curiosidades",
    "world.note": "Contenido cultural en revisión — presentado con respeto a las muchas formas de celebrar.",
    "surprise.btn": "Sorpréndeme",
    "surprise.title": "Una sugerencia para ti",
    "surprise.again": "Ver otra",
    "surprise.see": "Ver",
    "moment.choose": "Elige una experiencia para vivir antes de la cena.",
    "moment.prayer_card": "Oración de Navidad",
    "moment.prayer_desc": "Una oración cristiana para leer en familia.",
    "moment.gratitude_card": "Mensaje de Gratitud en Familia",
    "moment.gratitude_desc": "Un mensaje cálido, para cualquier familia.",
    "moment.open": "Abrir",
    "moment.reading_mode": "Modo Lectura",
    "moment.exit_reading": "Salir del modo lectura",
    "moment.back_choose": "Elegir otra experiencia",
  },
  fr: {
    "nav.world": "Noël dans le Monde", "nav.create": "Créer Mon Noël",
    "create.cta_title": "Créer Mon Noël",
    "create.cta_sub": "Répondez à quelques questions et laissez MY CHRISTMAS organiser chaque détail.",
    "create.start": "Commencer",
    "create.quick_title": "Je dois organiser mon Noël rapidement",
    "create.quick_sub": "Répondez à quelques questions et recevez un plan simplifié.",
    "create.quick_go": "Mode rapide",
    "dash.welcome_new": "Bienvenue sur MY CHRISTMAS",
    "dash.welcome_new_sub": "On prépare votre Noël ?",
    "dash.welcome_back": "Bon retour",
    "dash.continue": "Créer ma Planification",
    "dash.now_title": "Que faire maintenant",
    "dash.tasks_title": "Prochaines tâches",
    "dash.tools": "Outils",
    "dash.discover": "Découvrir",
    "dash.days_left": "Plus que {n} jours avant Noël 🎄",
    "dash.days_today": "C'est aujourd'hui ! Joyeux Noël 🎄",
    "dash.taking_shape": "Votre Noël prend forme.",
    "dash.your_plan": "Votre plan automatique", "dash.block_done": "Étape terminée", "dash.block_over": "Enregistrement {v} au-dessus du budget",
    "dash.reserved": "Budget réservé",
    "dash.edit_plan": "Modifier mon Noël",
    "wiz.title": "On prépare votre Noël ? 🎄",
    "wiz.step": "Étape {n} sur {total}",
    "wiz.q_country": "Où se passera votre Noël ?",
    "wiz.q_country_sub": "Cela définit la monnaie, les produits et les références de votre marché.",
    "wiz.q_language": "Dans quelle langue préférez-vous naviguer ?",
    "wiz.q_guests": "Combien de personnes célébreront avec vous ?",
    "wiz.q_audience": "Qui sera avec vous ?",
    "wiz.q_audience_sub": "Facultatif — cela nous aide à mieux planifier.",
    "wiz.q_budget": "Combien comptez-vous investir dans votre Noël ?",
    "wiz.budget_custom": "Ou saisissez le montant que vous allez utiliser",
    "wiz.budget_over": "Le montant dépasse votre budget",
    "wiz.q_split": "Voulez-vous répartir votre budget ?",
    "wiz.split_auto": "Laisser MY CHRISTMAS suggérer la répartition",
    "wiz.split_manual": "Je veux répartir manuellement",
    "wiz.q_style": "Quel Noël vous ressemble le plus ?",
    "wiz.q_haves": "Qu'avez-vous déjà à la maison ?",
    "wiz.q_haves_sub": "Ainsi nous ne suggérons pas d'acheter ce que vous avez déjà.",
    "wiz.q_ceia": "Comptez-vous préparer le repas ?",
    "wiz.q_ceia_level": "Quel type de repas ?",
    "wiz.q_dietary": "Une préférence alimentaire à prendre en compte ?",
    "wiz.q_secretsanta": "Y aura-t-il un Père Noël secret ? 🎁",
    "wiz.q_name": "Donnez un nom à votre Noël",
    "wiz.q_name_sub": "Il apparaîtra sur votre tableau de bord.",
    "wiz.q_cover": "Choisissez une couverture",
    "wiz.name_ph": "Ex. : Joyeux Noël",
    "wiz.processing": "Nous préparons votre Noël...",
    "wiz.p1": "Organisation de votre budget...",
    "wiz.p2": "Sélection d'inspirations...",
    "wiz.p3": "On pense à votre repas...",
    "wiz.p4": "Préparation de votre planning...",
    "wiz.p5": "Organisation de votre liste...",
    "wiz.ready": "Votre Noël est prêt à commencer",
    "wiz.summary": "Résumé de votre Noël",
    "wiz.finish": "Voir mon Noël",
    "wiz.next": "Continuer", "wiz.back": "Retour", "wiz.skip": "Passer",
    "wiz.guests_other": "Autre nombre :", "wiz.guests_ph": "ex. : 12", "wiz.people": "personnes", "wiz.yes": "Oui", "wiz.no": "Non",
    "wiz.quick_badge": "Mode rapide",
    "wiz.q_quick_needs": "Que devez-vous organiser ?",
    "split.decoration": "Décoration", "split.ceia": "Repas", "split.gifts": "Cadeaux",
    "split.table": "Table", "split.others": "Autres", "split.total": "Total",
    "world.title": "Noël dans le Monde",
    "world.sub": "Découvrez comment différents endroits célèbrent l'une des périodes les plus spéciales de l'année.",
    "world.explore": "Explorer", "world.back": "Retour au monde",
    "world.decoration": "Décoration", "world.food": "Plats", "world.dessert": "Desserts",
    "world.tradition": "Traditions", "world.table": "Table", "world.curiosity": "Curiosités",
    "world.note": "Contenu culturel en révision — présenté avec respect pour les multiples façons de célébrer.",
    "surprise.btn": "Surprenez-moi",
    "surprise.title": "Une suggestion pour vous",
    "surprise.again": "En voir une autre",
    "surprise.see": "Voir",
    "moment.choose": "Choisissez une expérience à vivre avant le repas.",
    "moment.prayer_card": "Prière de Noël",
    "moment.prayer_desc": "Une prière chrétienne à lire en famille.",
    "moment.gratitude_card": "Message de Gratitude en Famille",
    "moment.gratitude_desc": "Un message chaleureux, pour toute famille.",
    "moment.open": "Ouvrir",
    "moment.reading_mode": "Mode Lecture",
    "moment.exit_reading": "Quitter le mode lecture",
    "moment.back_choose": "Choisir une autre expérience",
  },
  it: {
    "nav.world": "Natale nel Mondo", "nav.create": "Crea il Mio Natale",
    "create.cta_title": "Crea il Mio Natale",
    "create.cta_sub": "Rispondi ad alcune domande e lascia che MY CHRISTMAS organizzi ogni dettaglio.",
    "create.start": "Inizia",
    "create.quick_title": "Devo organizzare il mio Natale in fretta",
    "create.quick_sub": "Rispondi ad alcune domande e ricevi un piano semplificato.",
    "create.quick_go": "Modalità rapida",
    "dash.welcome_new": "Benvenuto su MY CHRISTMAS",
    "dash.welcome_new_sub": "Prepariamo il tuo Natale?",
    "dash.welcome_back": "Bentornato",
    "dash.continue": "Crea la mia Pianificazione",
    "dash.now_title": "Cosa fare ora",
    "dash.tasks_title": "Prossime attività",
    "dash.tools": "Strumenti",
    "dash.discover": "Scopri",
    "dash.days_left": "Mancano {n} giorni a Natale 🎄",
    "dash.days_today": "È oggi! Buon Natale 🎄",
    "dash.taking_shape": "Il tuo Natale sta prendendo forma.",
    "dash.your_plan": "Il tuo piano automatico", "dash.block_done": "Fase completata", "dash.block_over": "Salvataggio {v} oltre il budget",
    "dash.reserved": "Budget riservato",
    "dash.edit_plan": "Modifica il mio Natale",
    "wiz.title": "Prepariamo il tuo Natale? 🎄",
    "wiz.step": "Passo {n} di {total}",
    "wiz.q_country": "Dove sarà il tuo Natale?",
    "wiz.q_country_sub": "Definisce valuta, prodotti e riferimenti del tuo mercato.",
    "wiz.q_language": "In quale lingua preferisci navigare?",
    "wiz.q_guests": "Quante persone festeggeranno con te?",
    "wiz.q_audience": "Chi sarà con te?",
    "wiz.q_audience_sub": "Facoltativo — ci aiuta a pianificare meglio.",
    "wiz.q_budget": "Quanto pensi di investire nel tuo Natale?",
    "wiz.budget_custom": "Oppure digita l'importo che userai",
    "wiz.budget_over": "L'importo supera il tuo budget",
    "wiz.q_split": "Vuoi dividere il tuo budget?",
    "wiz.split_auto": "Lascia che MY CHRISTMAS suggerisca la divisione",
    "wiz.split_manual": "Voglio dividerlo manualmente",
    "wiz.q_style": "Quale Natale ti rappresenta di più?",
    "wiz.q_haves": "Cosa hai già in casa?",
    "wiz.q_haves_sub": "Così non ti suggeriamo di comprare ciò che hai già.",
    "wiz.q_ceia": "Pensi di preparare la cena?",
    "wiz.q_ceia_level": "Che tipo di cena?",
    "wiz.q_dietary": "Qualche preferenza alimentare da considerare?",
    "wiz.q_secretsanta": "Ci sarà l'amico segreto? 🎁",
    "wiz.q_name": "Dai un nome al tuo Natale",
    "wiz.q_name_sub": "Apparirà nella tua dashboard.",
    "wiz.q_cover": "Scegli una copertina",
    "wiz.name_ph": "Es.: Buon Natale",
    "wiz.processing": "Stiamo preparando il tuo Natale...",
    "wiz.p1": "Organizzando il tuo budget...",
    "wiz.p2": "Selezionando ispirazioni...",
    "wiz.p3": "Pensando alla tua cena...",
    "wiz.p4": "Preparando la tua pianificazione...",
    "wiz.p5": "Organizzando la tua lista...",
    "wiz.ready": "Il tuo Natale è pronto per iniziare",
    "wiz.summary": "Riepilogo del tuo Natale",
    "wiz.finish": "Vedi il mio Natale",
    "wiz.next": "Continua", "wiz.back": "Indietro", "wiz.skip": "Salta",
    "wiz.guests_other": "Altro numero:", "wiz.guests_ph": "es. 12", "wiz.people": "persone", "wiz.yes": "Sì", "wiz.no": "No",
    "wiz.quick_badge": "Modalità rapida",
    "wiz.q_quick_needs": "Cosa devi organizzare?",
    "split.decoration": "Decorazione", "split.ceia": "Cena", "split.gifts": "Regali",
    "split.table": "Tavola", "split.others": "Altro", "split.total": "Totale",
    "world.title": "Natale nel Mondo",
    "world.sub": "Scopri come luoghi diversi celebrano uno dei periodi più speciali dell'anno.",
    "world.explore": "Esplora", "world.back": "Torna al mondo",
    "world.decoration": "Decorazione", "world.food": "Piatti", "world.dessert": "Dolci",
    "world.tradition": "Tradizioni", "world.table": "Tavola", "world.curiosity": "Curiosità",
    "world.note": "Contenuto culturale in revisione — presentato nel rispetto dei molti modi di celebrare.",
    "surprise.btn": "Sorprendimi",
    "surprise.title": "Un suggerimento per te",
    "surprise.again": "Vedine un altro",
    "surprise.see": "Vedi",
    "moment.choose": "Scegli un'esperienza da vivere prima della cena.",
    "moment.prayer_card": "Preghiera di Natale",
    "moment.prayer_desc": "Una preghiera cristiana da leggere in famiglia.",
    "moment.gratitude_card": "Messaggio di Gratitudine in Famiglia",
    "moment.gratitude_desc": "Un messaggio caloroso, per ogni famiglia.",
    "moment.open": "Apri",
    "moment.reading_mode": "Modalità Lettura",
    "moment.exit_reading": "Esci dalla modalità lettura",
    "moment.back_choose": "Scegli un'altra esperienza",
  },
};
